export default __webpack_public_path__ + "static/media/r1.535c2b56.jpeg";